import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { BuyButton } from './ui/BuyButton';
import { BRAND, offerIncludes, CHECKOUT_URL } from '../data/site';
import { usePricing } from '../hooks/usePricing';
interface OfferCardProps {
  showCountdown: boolean;
  countdown: {
    hours: string;
    minutes: string;
    seconds: string;
  };
}
export function OfferCard({
  showCountdown,
  countdown
}: OfferCardProps) {
  const pricing = usePricing();
  const timeUnits = [{
    value: countdown.hours,
    label: 'Horas'
  }, {
    value: countdown.minutes,
    label: 'Min'
  }, {
    value: countdown.seconds,
    label: 'Seg'
  }];
  return <section id="oferta" className="w-full bg-sage-800 px-5 py-16 sm:px-8 lg:py-28" aria-labelledby="oferta-titulo" data-id="element-108" data-mp="1ae7y4vr0cgf7">
      <div className="mx-auto max-w-3xl text-center" data-id="element-109" data-mp="15f53m58nlslh">
        <p className="flex items-center justify-center gap-3 text-[11px] font-semibold uppercase tracking-overline text-gold-200" data-id="element-110" data-mp="22x579t7hnsjc">
          <span className="h-px w-7 bg-gold-400/50" aria-hidden="true" data-id="element-111" data-mp="1y3k8hyy2muj3" />
          Tu acceso
          <span className="h-px w-7 bg-gold-400/50" aria-hidden="true" data-id="element-112" data-mp="8hw6899h7dfh" />
        </p>
        <h2 className="mt-5 font-serif text-[2rem] leading-[1.08] text-cream sm:text-[2.75rem]" data-id="element-113" data-mp="dee9f4p5r3pp">
          Convierte flores reales en creaciones que quieras{' '}
          <span className="italic text-gold-200" data-id="element-114" data-mp="3ob4c64rhzb0">conservar para siempre</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[15.5px] leading-relaxed text-sage-100 sm:text-[16px]" data-id="element-115" data-mp="3lu6ahh73h193">
          Recibe el método completo para aprender desde cero, evitar los errores más
          comunes y crear piezas decorativas, regalos, proyectos en resina y bordados
          botánicos.
        </p>
      </div>

      <div className="mx-auto mt-12 max-w-xl" data-id="element-116" data-mp="3gwnytj1p07xe">
        {showCountdown ? <div className="flex justify-center gap-3" data-editable="countdown-placeholder" data-id="element-117" data-mp="1b2o8batndbcl">
            {timeUnits.map(unit => <div key={unit.label} className="w-20 rounded-2xl border border-sage-700 bg-sage-900/60 py-3 text-center" data-id="element-118" data-mp="1f4rnoajft035">
                <p className="font-serif text-2xl text-cream" data-id="element-119" data-mp="2o29fkmvd1lwa">{unit.value}</p>
                <p className="mt-0.5 text-[10px] uppercase tracking-[0.16em] text-sage-200" data-id="element-120" data-mp="2j1lknq40gkws">
                  {unit.label}
                </p>
              </div>)}
          </div> : null}

        <div className="mt-7 overflow-hidden rounded-4xl bg-cream shadow-[0_40px_80px_-40px_rgba(0,0,0,0.6)]" data-id="element-121" data-mp="2a1outl5vxg05">
          <div className="border-b border-gold-200/70 bg-bone px-6 py-6 text-center" data-id="element-122" data-mp="36s7ikokawot2">
            <p className="text-[11px] font-semibold uppercase tracking-overline text-terracotta-500" data-id="element-123" data-mp="32qcl5v5hqvkk">
              Oferta por tiempo limitado
            </p>
            <h3 id="oferta-titulo" className="mt-3 font-serif text-[2rem] leading-none text-sage-800" data-id="element-124" data-mp="2xxjh79hujr9j">
              {BRAND.product}
            </h3>
            <p className="mt-2 text-[13px] text-ink-light" data-id="element-125" data-mp="3qg6y0cpt8k4t">{BRAND.subtitle}</p>
          </div>

          <div className="px-6 py-8 sm:px-10" data-id="element-126" data-mp="3lof3jr3j9u9e">
            <div className="mb-8 w-full rounded-3xl border-2 border-gold-200/60 bg-bone px-6 py-8 text-center shadow-inner" data-id="element-127" data-mp="3lnni393nhcwu">
              <p className="text-[12px] font-bold uppercase tracking-[0.2em] text-terracotta-600" data-id="element-128" data-mp="3t2fvvfip6nvd">
                Precio Especial
              </p>
              
              <div className="mt-3 flex items-center justify-center gap-3 text-ink-light" data-id="element-129" data-mp="6rbr464mnpix">
                <span className="text-[14px] font-medium uppercase tracking-wider" data-id="element-130" data-mp="av9p2di7uuae">Valor normal:</span>
                <span className="text-[18px] font-bold line-through decoration-terracotta-500/80 decoration-[3px]" data-id="element-131" data-mp="ft1t25w4y6uy">
                  {pricing.currency} {pricing.anchor}
                </span>
              </div>
              
              <div className="mt-2 flex items-baseline justify-center gap-2" data-id="element-132" data-mp="plh7wuc4yfbm">
                <span className="text-2xl font-bold text-sage-800" data-id="element-133" data-mp="uhxv9mbigpnn">{pricing.currency}</span>
                <span className={`font-serif text-[4rem] leading-none text-sage-900 transition-opacity duration-300 sm:text-[5rem] ${pricing.loading ? 'opacity-40' : 'opacity-100'}`} data-id="element-134" data-mp="ylnl0f3x9da9">
                  {pricing.loading ? '···' : pricing.price}
                </span>
              </div>
              
              <p className="mt-4 inline-block rounded-full bg-gold-200/50 px-4 py-1.5 text-[11.5px] font-bold uppercase tracking-wider text-sage-900" data-id="element-135" data-mp="lubujwfmxaav">
                Pago único · Acceso de por vida
              </p>
            </div>

            <ul className="space-y-3 border-b border-gold-200/70 pb-7" data-id="element-136" data-mp="uphuwfw4z060">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-137" data-mp="2vz858zpq3xc">
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-sage-700" data-id="element-138" data-mp="2xk6l9p5e70h">
                    <CheckIcon className="h-3 w-3 text-cream" aria-hidden="true" data-id="element-139" data-mp="gte28r0wuzvn" />
                  </span>
                  <span className="text-[15px] leading-snug text-sage-800" data-id="element-140" data-mp="bz0b50ta7ews">
                    {item}
                  </span>
                </li>)}
            </ul>

            <BuyButton size="xl" label="Quiero acceder ahora" href={CHECKOUT_URL} className="mt-7 w-full" data-id="element-141" data-mp="1nbaxaodiscs9" />

            <p className="mt-4 flex items-center justify-center gap-1.5 text-[11.5px] text-ink-light" data-id="element-142" data-mp="3584ljxonalbm">
              <LockIcon className="h-3 w-3" aria-hidden="true" data-id="element-143" data-mp="3a6fu8537eps9" />
              Pago seguro · Acceso inmediato por mail
            </p>
          </div>
        </div>
      </div>
    </section>;
}